import React, { useState } from 'react';
import { FaFileExport } from 'react-icons/fa';
import { toast } from 'react-toastify';
import deviceExportService from '../services/deviceExportService';

const DEVICE_LABELS = {
  mac: 'Macs',
  iphone: 'iPhones',
  ipad: 'iPads',
  appletv: 'Apple TVs'
};

/**
 * Compact export dropdown. Place next to search box.
 * @param {string[]} deviceTypes - e.g. ['mac','iphone','ipad','appletv'] for all, or ['appletv'] for single type
 * @param {{ [deviceType: string]: string[] }} [serialNumbersByType] - optional: restrict export to these serials per deviceType
 */
export default function DeviceExportDropdown({ deviceTypes = ['appletv'], serialNumbersByType = null }) {
  const [isExporting, setIsExporting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleExport = async (deviceType, format) => {
    if (isExporting) return;
    setIsExporting(true);
    setIsOpen(false);
    try {
      const serialNumbers = serialNumbersByType?.[deviceType];
      await deviceExportService.exportDevices(deviceType, format, { serialNumbers });
    } catch (err) {
      toast.error(err.response?.status === 401 ? 'Nicht autorisiert' : 'Export fehlgeschlagen');
    } finally {
      setIsExporting(false);
    }
  };

  const items = deviceTypes.flatMap((type) => [
    { deviceType: type, format: 'json', label: `${DEVICE_LABELS[type] || type} (JSON)` },
    { deviceType: type, format: 'csv', label: `${DEVICE_LABELS[type] || type} (CSV)` }
  ]);

  return (
    <div className="dropdown">
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded={isOpen}
        aria-haspopup="true"
        disabled={isExporting}
        title="Export"
      >
        <FaFileExport className="me-1" />
        {isExporting ? '…' : 'Export'}
      </button>
      <ul className="dropdown-menu dropdown-menu-end">
        {items.map(({ deviceType, format, label }) => (
          <li key={`${deviceType}-${format}`}>
            <button
              type="button"
              className="dropdown-item"
              onClick={() => handleExport(deviceType, format)}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
